import React from "react";
import onClickOutside from "react-onclickoutside";

import CircleGraph from "../../../components/graphs/CircleFillGraph";
import { DropDownButton } from "../../../components/StyledComponents";
import SmallDropdownIcon from "../../../components/icons/DropdownSmall";
import {
  DropdownGraphContainer2,
  SecondDropdownGraph,
  CircleDetail,
  DropdownGraphChild
} from "./styles";

const IndicatorsDropdown = ({
  dropDownTwoOpen,
  dropDownOneOpen,
  data,
  handleClick,
  handleDropdown
}) => {
  IndicatorsDropdown.handleClickOutside = () =>
    handleDropdown("dropDownTwoOutside");

  return (
    <div>
      <DropDownButton
        open={dropDownTwoOpen}
        onClick={() => handleDropdown("dropDownTwoOpen")}
        outlined={!dropDownTwoOpen}
      >
        <SmallDropdownIcon open={dropDownTwoOpen} />
        <span> تقييم المؤشرات</span>
      </DropDownButton>

      {dropDownTwoOpen && !dropDownOneOpen && (
        <DropdownGraphContainer2>
          {data.map((item, i) => (
            <DropdownGraphChild
              key={i}
              onClick={() => handleClick(item.id, "dropDownData2")}
              selected={item.selected}
            >
              <SecondDropdownGraph>
                <CircleGraph value={item.value} title={item.name} />
              </SecondDropdownGraph>

              <CircleDetail size="large">{item.name}</CircleDetail>
            </DropdownGraphChild>
          ))}
        </DropdownGraphContainer2>
      )}
    </div>
  );
};

const clickOutsideConfig = {
  handleClickOutside: () => IndicatorsDropdown.handleClickOutside
};

export default onClickOutside(IndicatorsDropdown, clickOutsideConfig);
